module.exports = __webpack_public_path__ + "img/Artboard.b10fd8e8.png";